import {
  READ_LOGIN,
  LOAD_LOGIN,
  RESET_LOGIN
} from "types/Types";

const initialState = {
  useraccount_id: "",
  username: "",
  password: "",
  firstName: "",
  lastName1: "",
  lastName2: "",
  email: "",
  email_host: "",
  email_port: 0,
  email_password: "",
  esir_username: "",
  esir_password: "",
  enabled: false,
  isAccountNonLocked: true,
  aliasuser: "",
  createdate: "",
  signature_default: "",
  language: {},
  defaultStore: {},  
  defaultEmployee: {},  
  defaulttypesdi: {},
  defaultslatype: {},
  roles: [],
  token: "",
  authorities: []
};

export function loginReducer(state = initialState, action) {
  switch (action.type) {
    case READ_LOGIN:
      return state;
    case LOAD_LOGIN: {
      const {
        id,
        username,
        password,
        firstName,
        lastName1,
        lastName2,
        email,
        email_host,
        email_port,
        email_password,
        esir_username,
        esir_password,
        enabled,
        isAccountNonLocked,
        aliasuser,
        createdate,
        signature_default,
        language,
        defaultStore,
        defaultEmployee,
        defaulttypesdi,
        defaultslatype,
        roles,
        token
      } = action.payload;
      
      return {
        ...state,
        useraccount_id: id || "",
        username: username || "",
        password: password || "",
        firstName: firstName || "",
        lastName1: lastName1 || "",
        lastName2: lastName2 || "",
        email: email || "",
        email_host: email_host || "",
        email_port: email_port || 0,
        email_password: email_password || "", 
        esir_username: esir_username || "",
        esir_password: esir_password || "",  
        enabled: enabled !== null ? enabled : true,
        isAccountNonLocked: isAccountNonLocked !== null ? isAccountNonLocked : true,
        aliasuser: aliasuser || "",
        createdate: createdate || "",
        signature_default:signature_default || "",
        language: language || {},
        defaultStore: defaultStore || {},
        defaultEmployee:defaultEmployee || {employee_id:0,fullname:"",numberdocument:"",vehiclestore:[]},
        defaulttypesdi: defaulttypesdi || {},
        defaultslatype: defaultslatype || {},
        roles: roles || [],
        token: token || ""
      };
    }
    case RESET_LOGIN:
      return initialState;
    default:
      return state;
  }
}
